// src/api.js
import axios from "axios";
import { setTokenExpiry } from "./utils/auth";

// Validate required environment variables
if (!process.env.REACT_APP_API_URL) {
  console.error("REACT_APP_API_URL is not defined in environment variables");
}

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});

// Request → Access Token inject
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

// Response → Token expiry handle
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const originalRequest = error.config;

    if (originalRequest?.url?.includes('/api/auth/verify-otp') && error.response?.status === 401) {
      return Promise.reject(error);
    }

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem("refreshToken");
        if (!refreshToken) {
          console.warn("No refresh token available");
          throw new Error("No refresh token");
        }

        const res = await axios.post(
          `${process.env.REACT_APP_API_URL || "http://localhost:8085"}/api/auth/refresh`,
          { refreshToken },
          { withCredentials: true }
        );

        const newAccessToken = res.data.accessToken;
        if (!newAccessToken) {
          throw new Error("No access token received");
        }

        localStorage.setItem("accessToken", newAccessToken);
        setTokenExpiry(); // Refresh token expiry time

        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
        return api(originalRequest);
      } catch (err) {
        console.error("Token refresh failed:", err.message);
        localStorage.clear();
        window.location.href = "/";
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);

export default api;